import { render } from "./recruitDetails.vue?vue&type=template&id=f7adb4ba&scoped=true"
import script from "./recruitDetails.vue?vue&type=script&lang=js"
export * from "./recruitDetails.vue?vue&type=script&lang=js"

import "./recruitDetails.vue?vue&type=style&index=0&id=f7adb4ba&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7adb4ba"]])

export default __exports__